import { loadMdBot } from '@liquidweb-dev/lw-chat-js';

/**
 * Opens the Methodic widget programmatically.
 * @param moduleUrl the Methodic widget module URL, from app config
 */
export default function openMethodicChat(moduleUrl: string): Promise<void> {
	return loadMdBot(moduleUrl).then((mod) => {
		mod.default.open();
	});
}
